import { DrawerState, ExpandableDrawer } from '@Components/expandable-drawer'
import * as Dialog from '@radix-ui/react-dialog'
import { useState } from 'react'
import { NumberGridInput } from '@Components/number-grid-input/number-grid-input'
import { Range } from '@interaction-gaming/game-data-service-browser-client'
import { NumberGridType } from '@Components/number-grid-input/number-grid-input-types'
import { Button } from '@Components/common/button'
import { BUTTON_TYPE } from '@Components/common/types'

export type MiniGameDrawerProps = {
  open: boolean
  spotOptions: Range
  initialNumberSelections: number[]
  miniGameName: string
  miniGameIconUrl?: string
  onClose: () => void
  onSubmit: (numberSelections: number[]) => void
}

const CLASS_NAME = 'gby-k2g-ticket-form-mini-game-drawer'

export const MiniGameDrawer = ({
  open,
  onClose,
  onSubmit,
  initialNumberSelections,
  miniGameName,
  miniGameIconUrl,
  spotOptions,
}: MiniGameDrawerProps) => {
  const [drawerOpen, onDrawerOpen] = useState(open)
  const [numbersSelected, onNumbersSelected] = useState<number[]>(initialNumberSelections)
  const onDrawerOpenChange = (isOpen: boolean) => {
    onDrawerOpen(isOpen)
    if (!isOpen) {
      onClose()
    }
  }

  return (
    <Dialog.Root open={drawerOpen} onOpenChange={onDrawerOpenChange}>
      <ExpandableDrawer
        classPrefix="gby-k2g-mini-game-drawer"
        drawerName={miniGameName}
        drawerIconUrl={miniGameIconUrl}
        hasCloseButton={false}
        state={open ? DrawerState.OPEN : DrawerState.CLOSED}
        scrollable={false}
        onOpenChange={onDrawerOpenChange}>
        <NumberGridInput
          className={CLASS_NAME}
          selections={numbersSelected}
          onSelectionChange={onNumbersSelected}
          maxSelections={spotOptions.min}
          gridType={NumberGridType.MINI_GAME}
          selectionError={numbersSelected.length > spotOptions.min}
        />
        <div className={`${CLASS_NAME}__footer-container`}>
          <Button text="Reset" onClick={() => onNumbersSelected([])} />
          <div>
            <Button text="Cancel" onClick={() => onDrawerOpenChange(false)} />
            <Button
              text="Submit"
              onClick={() => onSubmit(numbersSelected)}
              disabled={numbersSelected.length !== spotOptions.min}
              type={BUTTON_TYPE.SUBMIT}
            />
          </div>
        </div>
      </ExpandableDrawer>
    </Dialog.Root>
  )
}
